import { TrackerLoading } from '@/views/tracker/layout/tracker.loading';

export default TrackerLoading;
